import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify, type ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Rivulet Light — warm paper with teal ink
const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary:    '#0891B2',   // Cyan-600 — precise, editorial
    secondary:  '#64748B',   // Slate-500
    accent:     '#06B6D4',   // Cyan-400 highlight
    error:      '#EF4444',
    info:       '#0EA5E9',
    success:    '#10B981',
    warning:    '#F59E0B',
    background: '#F8F9FB',
    surface:    '#FFFFFF',
    'surface-variant': '#F1F5F9',
    'on-surface-variant': '#64748B',
  },
}

// Rivulet Dark — deep navy, glassy surfaces
const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary:    '#22D3EE',   // Cyan-400
    secondary:  '#94A3B8',   // Slate-400
    accent:     '#67E8F9',   // Cyan-300
    error:      '#F87171',
    info:       '#38BDF8',
    success:    '#34D399',
    warning:    '#FBBF24',
    background: '#0A0E1A',   // Very deep navy
    surface:    '#111827',   // Slightly lighter
    'surface-variant': '#1E293B',
    'on-surface-variant': '#94A3B8',
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
      rounded: 'lg',
      style: 'letter-spacing: 0; font-family: "DM Sans", sans-serif; font-weight: 500;',
    },
    VCard: {
      variant: 'elevated',
      rounded: 'xl',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
    },
    VChip: {
      rounded: 'md',
    },
    VList: {
      rounded: 'lg',
    },
    VListItem: {
      rounded: 'lg',
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
})
